/**
 * 从 AI 回复内容中提取快捷回复建议
 *
 * 匹配规则：每个「提示词 + 引号内容」独立匹配
 * - 中文引号 \u201c...\u201d
 * - 英文引号 "..."
 * - 引号前面有「回复/输入/发送」等提示词
 *
 * 仅提取短文本（\u226420字），避免把正常引用内容也当作按钮。
 */

/** 提示词：表示接下来引号里的内容是让用户回复的 */
const PROMPT_KEYWORDS = '(?:回复|输入|发送|告诉我|点击|确认|答复|响应)';

const PATTERNS: readonly RegExp[] = [
  // 中文引号: 回复\u201c确认生成\u201d
  new RegExp(`${PROMPT_KEYWORDS}[\\s，,：:]*\u201c([^\u201d]{1,20})\u201d`, 'g'),
  // 英文引号: 回复"确认生成"
  new RegExp(`${PROMPT_KEYWORDS}[\\s，,：:]*"([^"]{1,20})"`, 'g'),
];

/**
 * 去除行内 markdown 格式（粗体、斜体、行内代码等）
 * 例：**确认生成** → 确认生成
 */
const stripInlineMarkdown = (text: string): string =>
  text
    .replace(/\*\*(.+?)\*\*/g, '$1')  // **bold**
    .replace(/\*(.+?)\*/g, '$1')      // *italic*
    .replace(/__(.+?)__/g, '$1')      // __bold__
    .replace(/_(.+?)_/g, '$1')        // _italic_
    .replace(/`(.+?)`/g, '$1');       // `code`

/**
 * 从 AI 回复文本中提取快捷回复列表（去重）
 */
export const extractQuickReplies = (content: string): readonly string[] => {
  if (!content) return [];

  const results: string[] = [];
  const seen: Record<string, boolean> = {};

  for (const pattern of PATTERNS) {
    pattern.lastIndex = 0;
    let match: RegExpExecArray | null;
    while ((match = pattern.exec(content)) !== null) {
      const text = stripInlineMarkdown(match[1].trim());
      if (text && !seen[text]) {
        seen[text] = true;
        results.push(text);
      }
    }
  }

  return results;
};
